/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, InputSelect, Label, Modal, CustomLoading, Input, InputCheckbox, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../../Services/partscommandService";

/* 🧠 REDUX */
import { store } from "../../../../Redux/Store";
import { changeModal } from "../../../../Redux/Actions";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, PageTitle, ContainerList, 
    ContainerHead, ContainerRow, ButtonsContainer, ContainerColumn} from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const ListGroupVariables = () => {
    const { t } = useTranslation();

    document.title = "Grupos de variáveis";
    const Services = useRef(new PartsComandServices());
    const [partCommands, setPartCommands] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [parts, setParts] = useState([]);

    const partCommandField = useRef();
    const nameField = useRef();

    const partCommandValue = useRef();
    const nameValue = useRef();
    const isBombValue = useRef(false);

    useEffect(() => {
        async function getGroupsVariables(){
            let currentList = await Services.current.getGroupsVariables();
            setPartCommands(currentList)
            setIsLoading(false)
        }

        async function getPartCommand(){
            let currentItem = await Services.current.getAllPartCommands();
            setParts(currentItem);
        }

        getGroupsVariables();
        getPartCommand();
    },[])
    
    // Salva as edições do usuário
    async function Save(){
        store.dispatch(changeModal(''))
        if(isValidField(partCommandValue.current) && isValidField(nameValue.current)){

            let form = new FormData();
            if(partCommandValue.current){form.append('part_command_id', partCommandValue.current)}
            if(nameValue.current){form.append('name', nameValue.current)}
            form.append('isBomb', isBombValue.current ? 1 : 0)

    
            await Services.current.SaveGroupVariable(form)
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return(
        <>
            <Container>
                <PageTitle>
                    Grupos de variáveis
                </PageTitle>

                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + partCommands.length + " Grupos de variáveis" }
                    </CountContainer>

                    <Button onClick={()=>store.dispatch(changeModal('newPartCommand'))} width={'fit-content'} color={'green'} icon={''} text={"+ Criar novo Grupo"}></Button>
                </ContainerHead>

                <ContainerList>
                    <LineTitle>
                        <TitleText>Nome</TitleText>
                        {/* <TitleText>Comando</TitleText> */}
                    </LineTitle>

                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                        partCommands?.map((item, index)=>(
                            <LineList key={index} href={`/EncapsuledVariablesGroups/${item.id}`}>
                                <ListText>{item.name}</ListText>
                                {/* <ListText>{item.part_command_name}</ListText> */}
                            </LineList>
                        ))
                    }
                </ContainerList>
            </Container>
            
            <Modal title={t("administrative.partCommands.add")} name={'newPartCommand'} width={'70%'} height={'90%'} >
                
                <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                    <ContainerColumn>
                        <Label text={"part Command"} aling="flex-start"/>
                        <InputSelect
                            key={'part_command'}
                            name={'part_command'}
                            id={'part_command'}
                            placeholder={"Part Command"}
                            invalidMessage = {"Part Command inválido!"}
                            options={parts}
                            innerRef={partCommandField}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => partCommandValue.current = value}>
                        </InputSelect>                      
                    </ContainerColumn>

                    <ContainerColumn>
                        <Label text={"Nome"} aling="flex-start"/>
                        <Input
                            key={'name'}
                            name={'name'}
                            id={'name'}
                            placeholder={"Nome"}
                            invalidMessage = {"Nome inválida!"}
                            innerRef={nameField}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => nameValue.current = value}>
                        </Input>

                        <InputCheckbox text={t("inputs.isBomb.label")} onChange={(value)=> {isBombValue.current = value; return true}}/>
                    </ContainerColumn>
                </ContainerRow>

                
                <ButtonsContainer>
                    <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                    <Button text={t("buttons.cancel")} width={'150px'} color={'white-red'} onClick={()=>store.dispatch(changeModal(''))}/>
                </ButtonsContainer>
            </Modal>
        </>
    )
}

export default ListGroupVariables;